export enum TYPE_IROPS {
  CANCELED = 1,
  DELAYED = 2,
  STBFULLIST = 3,
  Onboarding = 4,
  USPERSONINFO,
}

export enum IROPS_STATUS {
  SCHEDULED = 'Scheduled',
  DELAYED = 'Delayed',
  EARLY = 'Early',
  CANCELLED = 'Cancelled',
  Onboarding = 'onboarding',
  ON_TIME = 'on_time',
  USED = 'USED',
  ARU_NO_FLIGHT_STATUS = 'AruNoFlightStatus',
}

export enum IROPS_FLIGHT_EXCHANGE_TYPE {
  ITINERARY = 'itinerary',
  OUTBOUND = 'outbound',
  INBOUND = 'inbound',
}

export enum IROPS_TYPE {
  DELAY = 'delay',
  EARLY = 'early',
  CANCEL = 'cancel',
}

export enum IROPS_AFFECTATION {
  MAJOR = 'major',
  MINOR = 'minor',
}

export enum IROPS_WINDOW {
  COMMERCIAL = 'commercial',
  OPERATIONAL = 'operational',
}

export enum IROPS_ELIGIBILITY_CODE {
  CANCELLED = 'IROPS_NON_ELIGIBLE_CANCELLED',
  MINUTES = 'IROPS_NON_ELIGIBLE_MINUTES',
  MULTICITY = 'IROPS_NON_ELIGIBLE_MULTICITY',
  UNMR = 'IROPS_NON_ELIGIBLE_UNMR',
  PETS = 'IROPS_NON_ELIGIBLE_PETS',
  EMPLOYEE = 'IROPS_NON_ELIGIBLE_EMPLOYEE',
  GROUP = 'IROPS_NON_ELIGIBLE_GROUP',
  ONHOLD = 'IROPS_NON_ELIGIBLE_ONHOLD',
  INTERLINE = 'IROPS_NON_ELIGIBLE_INTERLINE',
  GENERIC = 'IROPS_NON_ELIGIBLE_GENERIC',
  MULTIPLE_TICKETS = 'IROPS_NON_ELIGIBLE_MULTIPLE_TICKETS',
  NO_SEGMENTS = 'IROPS_NON_ELIGIBLE_NO_SEGMENTS',
  UNPAID = 'IROPS_NON_ELIGIBLE_UNPAID',
  CORPORATE = 'IROPS_NON_ELIGIBLE_CORPORATE',
  BASIC_FARE_NEW_BF = 'IROPS_NON_ELIGIBLE_BASIC_FARE_NEW_BF',
  BASIC_FARE = 'IROPS_NON_ELIGIBLE_BASIC_FARE',
  CHECKED_BAGS = 'IROPS_NON_ELIGIBLE_CHECKED_BAGS',
  PAID_BY_AMR = 'IROPS_NON_ELIGIBLE_PAID_BY_AMR',
  OPERATING_DL = 'IROPS_NON_ELIGIBLE_OPERATING_DL',
  INVALID_CURRENCY = 'IROPS_NON_ELIGIBLE_INVALID_CURRENCY',
  SEGMENT_STATUS_MM = 'IROPS_NON_ELIGIBLE_SEGMENT_STATUS_MM',
  ANCILLARIES_DIFFERENT_BRANDS = 'IROPS_NON_ELIGIBLE_ANCILLARIES_DIFFERENT_BRANDS',
  RESERVATION_SC_STATUS = 'IROPS_NON_ELIGIBLE_RESERVATION_SC_STATUS',
  BLOCKED_ANCILLARY = 'IROPS_NON_ELIGIBLE_BLOCKED_ANCILLARY',
  INFANT_NOT_SEAT = 'IROPS_NON_ELIGIBLE_INFANT_NOT_SEAT',
  STATUS_VCR = 'IROPS_NON_ELIGIBLE_STATUS_VCR',
  EXPIRED_SEGMENTS = 'IROPS_NON_ELIGIBLE_EXPIRED_SEGMENTS',
  INVOL_INVALID_EXCHANGE_DATE = 'IROPS_NON_ELIGIBLE_INVOL_INVALID_EXCHANGE_DATE',
  VOL_INVALID_EXCHANGE_DATE = 'IROPS_NON_ELIGIBLE_VOL_INVALID_EXCHANGE_DATE',
  NOT_DECIMALS_IN_RESERVATION = 'IROPS_NON_ELIGIBLE_NOT_DECIMALS_IN_RESERVATION',
}

export const COMMERCIAL_WINDOW_HOURS = 72;
export const DELAY_MAJOR_THRESHOLD_MINUTES = 30;
export const EARLY_MAJOR_THRESHOLD_MINUTES = 15;
